<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-18 18:15:14
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/list/components/SwitchBarList/index.vue
-->
<template>
  <div class="switch_list_bar">
    <div
      v-for="(item, index) in orderStatusList"
      :key="index"
      class="font12 font_weight400 colo087 switch_item"
      @click="clickSwitch(index)"
    >
      <div>{{ item }}</div>
      <div v-if="switchIndex === index" class="switch_line"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    switchIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      orderStatusList: ["全部", "待付款", "待发货", "待收货", "已完成"]
    };
  },
  methods: {
    clickSwitch(index) {
      this.$emit("clickSwitch", index);
    }
  }
};
</script>
<style lang="less" scoped>
.switch_list_bar {
  background: #fff;
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  display: flex;
  box-shadow: 0px 3px 6px -3px rgba(193, 200, 207, 0.5);
  border-radius: 0px 0px 8px 8px;
  z-index: 100;
  // justify-content: space-between;
  .switch_item {
    flex: 1;
    margin-top: 15px;
    .switch_line {
      width: 24px;
      height: 3px;
      background: #bf9264;
      border-radius: 1px;
      margin: 13px auto 0;
    }
  }
}
</style>
